import React from "react"
import { graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"

class MainIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={`Main`}
          keywords={[`Japanese`, `travel`, `personal development`, `Korean`, `blog`, `gatsby`, `javascript`, `react`]}
        />
        <Bio />
        <p>
          This is a website for me to show off cool projects, keep tools, write blog posts to help others and cement my own understanding, and connect with others.
        </p>
      </Layout>
    )
  }
}

export default MainIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
